

<template>
  <div>

    <a-card class="all-card-style " >
      <div style="margin-top:20px;">
        <a-button type="primary" html-type="submit" @click="toAddPage(1,'')">
          +新建主干管
        </a-button>


        <a-button type="primary" html-type="submit" @click="toDown" style="margin-left:20px;">
        下载模板
        </a-button>
        <a-upload
          name="file"
          :multiple="false"
        @change="uploadchange"  :customRequest="customRequest"
        style="margin-left:20px;"
      >
        <a-button> <a-icon type="upload" /> 导入 </a-button>
      </a-upload>
        <vxe-table
          style="margin-top:20px;width:100%;"
        resizable
        row-id="ID"
          :data="tableData"
          :on-error="upLoadError"
          :tree-config="{children: 'children', expandAll: true}"
        :checkbox-config="{labelField:'cName'}"
        border="inner"
          @checkbox-change="selectChangeEvent"
     >







          <vxe-table-column type="checkbox" title="名称" tree-node ></vxe-table-column>
          <vxe-table-column title="操作"  show-overflow width="300">
            <template v-slot="{ row }">
              <vxe-button type="text" icon="fa fa-edit" @click="toAddPage2(row)" v-if="row.iTypeID<4">新增</vxe-button>
              <vxe-button type="text" icon="fa fa-edit" @click="toEditPage(row)">修改</vxe-button>
              <vxe-button type="text" icon="fa fa-edit" @click="showDeleteModal(row)">删除</vxe-button>
            </template>
          </vxe-table-column>
        </vxe-table>
      </div>
    </a-card>
    <a-modal v-model="deleteModalVisible" title="删除" @ok="handleDelete" ok-text="确认" cancel-text="取消">
      <p>是否删除</p>
    </a-modal></div>
</template>
<script>
  export default {
    data () {
      return {
        record:[],
        uploadurl:"",
        deleteModalVisible:false,
        queryInfo:{},
        tableData: [
        ],
        defaultExpandKeys: [],
      }
    },
    mounted () {
      this.getTableData();
      this.uploadurl=this.$http.defaults.baseURL+"EntWLWCropWaterPipe/Upload";
     // this.uploadurl=this.$http.defaults.baseURL+"EntWLWCropWaterPipe/Upload";
    },

    created () {
      this.defaultExpandKeys = ['30000']
      //  this.tableData = window.MOCK_TREE_DATA_LIST
    }
    ,
    methods:{
      toDown(){
window.open('http://sa.eragood.com/IFSInterface/template.xls');
      },
      saveFile (formData) {
        let that=this;
        const hide = this.$message.loading('正在导入数据请稍候..', 0)
        this.$axios({
          method: 'post',
          url:      this.uploadurl,
          headers: {
          },
          params:{
            cEntID: that.$store.getters.User.enterprise.ID
          },
          data: formData
        }).then((response) => {

          location. reload()
          setTimeout(hide,2000);
        }).catch(function (error) {
          console.log(error)
          location. reload()
          setTimeout(hide,2000);
        })

      },

      beforeUpload(){


      },customRequest(data){ // 上传提交
        let formDatas = new FormData() ;
        formDatas.append('file', data.file)
        formDatas.append('token', "token")

        this.saveFile(formDatas)
      },
      upLoadSuccess(response, file, fileList) {
        if (response == "ok") {

        } else {

        }
      },//文件上传失败时的钩子
      upLoadError(response, file, fileList) {

      },
      uploadchange(e){},
      selectChangeEvent ({ records }) {

      },
      showDeleteModal:function (obj) {
        this.record=obj;
        this.deleteModalVisible=true;
      },
      //删除
      async handleDelete(){
        let that=this;
        let param={ids:that.record.ID};
        let res=await that.$http.post('EntWLWCropWaterPipe/sDel?ids='+that.record.ID,param)


        if(res.data.code=="200"){
          this.deleteModalVisible=false;
          that.$message.success(res.data.message)
          that.getTableData();
        }
        else{
          that.$message.error(res.message)

        }
      },
      async getTableData(){
        var _this=this
        _this.queryInfo.cEntID=_this.$store.getters.User.enterprise.ID;
        let res=await _this.$http.post('EntWLWCropWaterPipe/AllList',_this.queryInfo)

        if(res.data.code ==200){
          _this.tableData=res.data.obj.list
          if(!!     _this.tableData){
            for(let i=0;i<     _this.tableData.length;i++){
             // _this.tableData[i].rid=i+1;

             //_this.tableData[i].parentid=  _this.tableData[i].cParentID;
            }
          }


       //   _this.pagination.total=res.data.obj.listTotal

        }
        else{

        }
      },
      toEditPage(item){
        if(item.iTypeID==1){
          this.$router.push({name:'EntWLWCropWaterPipeAdd', params: { iTypeID: "1" ,ID:item.ID}})
        } if(item.iTypeID==2){
          this.$router.push({name:'EntWLWCropWaterPipeAdd', params: { iTypeID: "2" ,ID:item.ID}})
        }
        if(item.iTypeID==3){
          this.$router.push({name:'EntWLWCropWaterPipeAdd', params: { iTypeID: "3" ,ID:item.ID}})
        }if(item.iTypeID==4){
          this.$router.push({name:'EntWLWCropWaterPipeAdd2', params: { iTypeID: "4" ,ID:item.ID}})
        }
      },
      toAddPage(iTypeID,cParentID){

        if(iTypeID==1){
          this.$router.push({name:'EntWLWCropWaterPipeAdd', params: { iTypeID: iTypeID+"" ,cParentID:cParentID}})
        }

      },
      toAddPage2(item){
        if(item.iTypeID==1){
          this.$router.push({name:'EntWLWCropWaterPipeAdd', params: { iTypeID: "2" ,cParentID:item.ID}})
        } if(item.iTypeID==2){
          this.$router.push({name:'EntWLWCropWaterPipeAdd', params: { iTypeID: "3" ,cParentID:item.ID}})
        }if(item.iTypeID==3){
          this.$router.push({name:'EntWLWCropWaterPipeAdd2', params: { iTypeID: "4" ,cParentID:item.ID}})
        }
      },
    },
  }
</script>
<style>

</style>
